import React from 'react';
import ConteudoApp from './ConteudoApp';

export const ConteudoConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/conteudo',
            component: () => <ConteudoApp Label={"Conteúdo"} />
        }
    ]
};
